import * as React from "react";

export interface GlobalSearchContextValue {
  /** Open the command palette. */
  open: () => void;
  /** Close the command palette. */
  close: () => void;
  /** Whether the palette is currently open. */
  isOpen: boolean;
}

export const GlobalSearchContext =
  React.createContext<GlobalSearchContextValue | null>(null);

/**
 * Imperative handle for the global command palette. Must be used inside a
 * `<GlobalSearchProvider>`.
 */
export function useGlobalSearch(): GlobalSearchContextValue {
  const ctx = React.useContext(GlobalSearchContext);
  if (!ctx) {
    throw new Error(
      "useGlobalSearch must be used within a <GlobalSearchProvider>"
    );
  }
  return ctx;
}
